'use strict';

$(document).ready(function () {

  var Nette = {noInit: true};
  // mobile menu

  $(".js-mobileNavigation").on('click', function (e) {
    e.preventDefault();
    $(".navigation").fadeToggle(200);
    $(this).toggleClass('is-active');
  });

  // slider

  $('.js-slider').slick({
    arrow: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 8000,
    appendArrows: $('.js-arrow'),
    prevArrow: '<a href="#" class="section-hp__link section-hp__link--effect1"><</a>',
    nextArrow: '<a href="#" class="section-hp__link section-hp__link--effect2">></a>'
  });

  // slider 2

  $('.js-slider2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    appendDots: $('.js-arrow2')
  });


  $('.js-slider3').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000
  });

  // counter

  var toggled = false;
  $(window).scroll(function () {
    if ($(this).scrollTop() > 10) {
      if(!toggled){
        $('.count').each(function () {
          $(this).prop('Counter',0).animate({
            Counter: $(this).text()
          }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
              $(this).text(Math.ceil(now));
            }
          });
        });
        toggled = true;
      }
    }
  });

  $(".unhide1").on( "click", function( event ) {
    event.preventDefault();
    $(".initially-hidden1").toggle("slide");
  });

  $(".unhide2").on( "click", function( event ) {
    event.preventDefault();
    $(".initially-hidden2").toggle("slide");
  });
  $(".unhidecv").on( "click", function( event ) {
    event.preventDefault();
    $(this).next(".cv").toggle("slide");
  });
});
